<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card title="Available in Countries">
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
      <p class="pb-3">
        A list of comma separated "IANA Language Region Subtag" country codes indicating what countries this product is available in.
        <br/>
        <a target="_blank" href="https://www.iana.org/assignments/language-subtag-registry/language-subtag-registry">Click here</a> for a list of all the Subtags (make sure to only use tags of 'Type: region')
        <vs-divider class="mb-2" />
        Use <span class="text-primary"><b>!=</b></span> at the start of the list to make it <span class="text-primary"><b>exclusive</b></span>. For example:
        <br/>
        <span class="text-primary"><b>US,CA,MX</b></span> = available only in US, CA, and MX
        <br/>
        <span class="text-primary"><b>!=US,CA,MX</b></span> = available everywhere <span class="text-primary"><b>except</b></span> US, CA, and MX
        <vs-divider class="mb-2" />
        Using the code <span class="text-primary"><b>EU</b></span> will include/exclude these countries:
        <br/>
        <span class="text-xs">AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SW,GB,UK,JE,NO,LI,CH,MO,RU,BY,UA,KZ,UZ,RS</span>
        <vs-divider class="mb-2" />
        Leaving this blank/empty means available in all countries
      </p>

      <div class="vx-row mb-2 mt-3">
        <div class="vx-col w-full">
          <vs-input
            :label="`Country List`"
            :placeholder="`Available Everywhere`"
            v-model="workingCountries"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mt-8">
        <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2" @click="saveChanges"><vs-button class="mx-1 w-full">Save Changes</vs-button></div>
        <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full" color="warning" type="border" @click="revert">Cancel</vs-button></div>
      </div>

    </vx-card>
<!--    <div v-html="jp.toHtml(cyclopedias)"></div>-->
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  import { productHelpers } from '@/models/helpers'

  export default {
    components: {},
    data() {
      return {
        loading: false,
        models: models,
        productHelpers: productHelpers,
        newFrequencyModel: new models.ProductFrequency(),
        originalCountries: '',
        workingCountries: '',
      }
    },
    props: {
      product: {
        type: models.Product(),
        required: true,
        default: () => {
          return new models.Product()
        }
      },
    },
    watch: {
      product: function (newVal, oldVal) {
        if (newVal.available_countries === oldVal.available_countries) return;
        this.originalCountries = newVal.available_countries;
        this.workingCountries = newVal.available_countries;
      },
      workingCountries: function (newVal) {
        if (newVal) {
          this.workingCountries = newVal.toUpperCase().replaceAll(' ', '').trim();
        }
      },
      isModified: function (newVal, oldVal) {
        if (newVal === oldVal) return;
        this.$emit('unsavedChangesUpdate', newVal);
      }
    },
    computed: {
      productId() {
        return this.$route.query.id || null;
      },
      isModified() {
        return this.originalCountries !== this.workingCountries;
      },
      validateCountries() {
        if (this.workingCountries === '' || this.workingCountries === null || this.workingCountries === 'undefined') {
          return true;
        }
        const re = /^(!=)?([A-Z]{2})(,[A-Z]{2})*$/;
        return re.test(this.workingCountries);
      },
    },
    mounted() {
      console.log(this.product.available_countries);
      this.originalCountries = this.product.available_countries;
      this.workingCountries = this.product.available_countries;
    },
    methods: {
      revert() {
        this.workingCountries = this.originalCountries;
      },
      async saveChanges() {
        if (!this.isModified) return;
        this.loading = true;

        let success = false;
        let errorMessage = 'Error saving changes';
        if (!this.validateCountries) {
          errorMessage = 'Invalid format. Use comma-separated, two-letter country codes.'
        } else {
          success = await api.saveProductBaseProperties(new models.Product({...this.product, available_countries: this.workingCountries}) );
        }

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: success ? `Changes successfully saved` : errorMessage,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});

        this.originalCountries = this.workingCountries;

        this.revert();

        this.$emit('productChanged');

        this.loading = false;
      },
    },
  }

</script>


<style lang="scss">

</style>

